import React, { useEffect, useRef } from 'react';
import { AlertTriangle, Save, Slash } from 'react-feather';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { startloadClientes, startRegistroCliente } from '../../../../app/store/clientes/thunks';
import Swal from 'sweetalert2';

export const NewCustomer = ({ variant }) => {
    const dispatch = useDispatch();
    const { tiposClientes, como_conocieron } = useSelector(state => state.catalogos);
    const { status, isLoading, msg } = useSelector(state => state.clientes);
    const { usuario } = useSelector(state => state.usuario);

    // console.log(msg);

    const closeModal = useRef(null);
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({
        defaultValues: {
            nombreCliente: "",
            telefonoCliente: "",
            celularCliente: "",
            emailCliente: "",
            tipoCliente: "",
            comoConocio: ""
        }
    });
    const solo_num = (e) => {
        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Decimal', '.'
        ];

        const inputValue = e.target.value;
        const hasDecimal = inputValue.includes('.');

        // Si ya existe un punto decimal, solo permitir dos dígitos después de él
        if (hasDecimal && inputValue.split('.')[1].length >= 2 && (e.key >= '0' && e.key <= '9')) {
            e.preventDefault(); // Evitar más de 2 dígitos después del punto decimal
            return;
        }

        if ((e.key >= '0' && e.key <= '9') || // Números
            allowedKeys.includes(e.key) // Otras teclas permitidas
        ) {
            return true;
        } else {
            e.preventDefault(); // Evitar cualquier otra tecla
        }
    };
    // console.log(como_conocieron);

    const clearForm = () => {
        reset();
        dispatch(startloadClientes())
    }

    const handledSaveCliente = (data) => {
        // console.log(data);
        let flag = 0;

        if (msg == null || msg == undefined || msg == "") {
            dispatch(startRegistroCliente(data, usuario, flag,variant));
            closeModal.current.click();
        } else {

            flag = 1;
            Swal.fire({
                title: 'Atención',
                text: "Está por registrar a un cliente, con un telefono/ celular ya registrado, ¿Desea de continuar con esta acción?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3b7ddd',
                cancelButtonColor: '#dc3545',
                cancelButtonText: 'No',
                confirmButtonText: 'Si'
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(dispatch(startRegistroCliente(data, usuario, flag,variant)));
                    closeModal.current.click();
                }
            })
        }
    }

    useEffect(() => {
        if (status == 'CLIENTES_CARGADOS') {
            reset();
            closeModal.current.click();
            // window.location.reload();
        }
    }, [status])


    return (
        <div className="modal fade" id="newCliente" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Nuevo Cliente</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearForm}></button>
                    </div>
                    <form onSubmit={handleSubmit(handledSaveCliente)}>
                        <div className="modal-body">
                            <div className="row">

                                <div className='col-12'>
                                    {
                                        (msg) ?
                                            <div className="alert alert-warning" role="alert">
                                                El telefono o celular ya esta registrado:<br /> {msg}
                                            </div> : <></>
                                    }

                                </div>
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label">Nombre:</label>
                                        <input type="text" className="form-control" aria-label="First name" autoComplete='off' {...register("nombreCliente", { required: 'Nombre del cliente es requerido.' })} />
                                        {
                                            errors.nombreCliente &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.nombreCliente.message}</small></span>
                                            </div>
                                        }
                                    </div>

                                </div>

                                <div className="col-6">
                                    <div className="mb-3">
                                        <label className="form-label">Telefono:</label>
                                        <input type="number" className="form-control" aria-label="First name" autoComplete='off' onKeyDown={solo_num} {...register("telefonoCliente", {
                                            required: 'Telefono del cliente es requerido.',
                                            minLength: { value: 10, message: 'Telefono debe terner minimo 10 digitos' },
                                            maxLength: { value: 10, message: 'Telefono debe terner maximo 10 digitos' }
                                        })} />
                                        {
                                            errors.telefonoCliente &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.telefonoCliente.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="mb-3">
                                        <label className="form-label">Celular:</label>
                                        <input type="number" className="form-control" aria-label="First name" autoComplete='off' onKeyDown={solo_num}
                                            {...register("celularCliente", {
                                                required: 'Celular del cliente es requerido.',
                                                minLength: { value: 10, message: 'Celular debe terner minimo 10 digitos' },
                                                maxLength: { value: 10, message: 'Celular debe terner maximo 10 digitos' }
                                            }
                                            )} />
                                        {
                                            errors.celularCliente &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.celularCliente.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-8">
                                    <div className="mb-3">
                                        <label className="form-label">Correo electronico:</label>
                                        <input type="email" className="form-control" aria-label="First name" autoComplete='off'
                                            {...register("emailCliente", {
                                                required: 'Correo del cliente es requerido.',
                                                pattern: {
                                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                    message: 'Introduce una direccion de correo',
                                                },
                                            })} />
                                        {
                                            errors.emailCliente &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.emailCliente.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div className="mb-3">
                                        <label className="form-label">F. Nacimiento:</label>
                                        <input type="date" className="form-control" aria-label="First name" autoComplete='off'
                                            {...register("nacimientoCliente", { required: 'Fecha Nacimiento.' })} />
                                        {
                                            errors.nacimientoCliente &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.nacimientoCliente.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-6">
                                    <label className="form-label ">Clasificacion de Cliente:</label>
                                    <select className="form-select" {...register('tipoCliente', { required: 'Debe seleccionar la Clasificacion de Cliente' })}>
                                        <option value="">Seleccione una clasificacion</option>
                                        {
                                            tiposClientes.map((item, index) => (
                                                item.ESTADO == 1 ? <option key={index} value={item.ID} className='text-uppercase' >{item.NOMBRE}</option>
                                                    : <option key={index} style={{ display: "none" }} ></option>
                                            ))
                                        }
                                    </select>
                                    {
                                        errors.tipoCliente &&
                                        <div className='text-left-5 mt-2'>
                                            <AlertTriangle size="18" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.tipoCliente.message}</small></span>
                                        </div>
                                    }
                                </div>

                                <div className="col-6">
                                    <label className="form-label ">¿Como nos conocio?:</label>
                                    <select className="form-select" {...register('comoConocio', { required: 'Debe seleccionar como nos conocio el Cliente' })}>
                                        <option value="">Seleccione una clasificacion</option>
                                        {
                                            como_conocieron.map((item, index) => (
                                                item.ESTADO == 1 ? <option key={index} value={item.ID} className='text-uppercase' >{item.DESCRIPCION}</option>
                                                    : <option key={index} style={{ display: "none" }} ></option>
                                            ))
                                        }
                                    </select>
                                    {
                                        errors.comoConocio &&
                                        <div className='text-left-5 mt-2'>
                                            <AlertTriangle size="18" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.comoConocio.message}</small></span>
                                        </div>
                                    }
                                </div>

                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" ref={closeModal} hidden className="btn btn-secondary" data-bs-dismiss="modal" >CERRAR</button>
                            <button type="button" className="btn btn-outline-danger" data-bs-dismiss="modal" onClick={clearForm}>
                                <Slash size='20' /> Cancelar
                            </button>
                            <button type="submit" className="btn btn-outline-primary" >
                                <Save size="20" /> Guardar
                            </button>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    )
}
